import { memo } from 'react';
import { CgChevronDown } from 'react-icons/cg';
import { components, DropdownIndicatorProps } from 'react-select';
import { Icon } from '@chakra-ui/react';

import { ControlledSelectOption } from '../types/ControlledSelectOption';

const DropdownIndicatorComponent = <IsMulti extends boolean = false>({
  children,
  ...props
}: DropdownIndicatorProps<ControlledSelectOption, IsMulti>) => (
  <components.DropdownIndicator {...props}>
    <Icon as={CgChevronDown} boxSize={5} />
  </components.DropdownIndicator>
);

export const DropdownIndicator = memo(
  DropdownIndicatorComponent,
) as typeof DropdownIndicatorComponent;
